import { WrapperApp } from './AdminApp';
import './App.css';
import { RecieverApp } from './components/PushReciever/RecieverApp';
function App() {
  return (
    <div className="App">
        <WrapperApp />
    </div>
  );
}

export default App;
